<template>
  <div>
    <Modal
      id="change-contractor"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Выбор исполнителя</span>
      </template>
      <template v-slot:default>
        <div class="grid-y space-y-2 p-8">
          <div class="cell">
            <IwalyInput
              class="input-group-sm"
              classes="bg-zircon border-none"
              placeholder="Поиск по имени исполнителя"
              @keyup.enter.native="find"
              @blur="blur">
              <template slot="input:prepend">
                <div class="icon h-full">
                  <img class="h-full" src="@/assets/icons/loupe.svg" alt="">
                </div>
              </template>
            </IwalyInput>
          </div>
          <div
            class="cell overflow-y-auto"
            :style="{ maxHeight: '432px' }">
            <div class="flex flex-col divide-y">
              <div
                class="flex flex-row items-center space-x-6 py-3 pr-5 cursor-pointer"
                v-for="(contractor, index) in contractors"
                :key="index"
                @click.prevent="setContractor(contractor)">
                <div class="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
                  <Attachment
                    class="object-cover object-center"
                    :id="contractor.photoAttach"
                    v-if="contractor.photoAttach"/>
                  <img
                    class="object-cover object-center"
                    src="@/assets/icons/user.svg">
                </div>
                <div class="flex flex-col flex-grow">
                  <b>{{ contractor.name }}</b>
                  <span>ID: {{ contractor.id }}</span>
                </div>
                <div class="flex flex-row">
                  <b></b>
                </div>
                <Check
                  :value="selected === contractor.id"/>
              </div>
            </div>
            <infinite-loading
              @infinite="onInfiniteLoading">
              <div slot="spinner"></div>
              <div slot="no-more"></div>
              <div slot="no-results"></div>
              <div slot="error"></div>
            </infinite-loading>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="flex space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="$bvModal.hide('change-contractor')">Отмена</button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            @click="change()">Выбрать исполнителя</button>
        </div>
      </template>
    </Modal>
    <Modal
      id="changed-contractor"
      :hide-footer="true"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Исполнитель успешно изменен</span>
      </template>
      <template v-slot:default>
        <div class="flex flex-col items-center p-8">
          <p class="text-center text-16px leading-22px mb-6 text-muted">
            Исполнители получили необходимые уведомления о внесенных изменениях.
          </p>
          <button
            class="btn btn-sm btn-primary"
            @click="$bvModal.hide('changed-contractor')">
            Понятно
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';
import Check from '@/components/Check.vue';
import Attachment from '@/components/global/Attachment.vue';

export default {
  components: {
    Modal,
    IwalyInput: Input,
    Check,
    Attachment,
    InfiniteLoading,
  },
  data() {
    return {
      query: '',
      selected: null,
    };
  },
  computed: {
    ...mapState({
      payload: (state) => state.contractors.simple,
    }),
    contractors() {
      return _.get(this.payload, 'payload') || [];
    },
    total() {
      return _.get(this.payload, 'total');
    },
    completed() {
      if (!this.contractors.length && this.total === null) {
        return false;
      }
      return this.contractors.length === parseInt(this.total, 10);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'contractors/ACT_SIMPLE_FETCH_CONTRACTORS',
      clear: 'contractors/ACT_CLEAR_SIMPLE_CONTRACTORS',
    }),
    onInfiniteLoading($state) {
      if (!this.completed) {
        this.fetch({
          query: this.query,
        }).then(() => {
          this.$nextTick().then(() => {
            if (this.completed) {
              $state.complete();
            } else {
              $state.loaded();
            }
          });
        }).catch(() => {
          $state.error();
        });
      }
    },
    find(event) {
      const { value } = event.target;
      if (value !== '') {
        this.query = value;
      }
      event.target.blur();
    },
    blur(event) {
      const { value } = event.target;
      if (value === '') {
        this.query = value;
      }
    },
    setContractor(contractor) {
      const { id } = contractor;
      if (this.selected === id) {
        this.selected = null;
      } else {
        this.selected = id;
      }
    },
    change() {
      this.$emit('submit', this.selected);
    },
  },
  watch: {
    query(newQuery, oldQuery) {
      if (newQuery !== oldQuery) {
        this.clear().then(() => {
          this.fetch({
            query: this.query,
          });
        });
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (event, modalId) => {
      switch (modalId) {
        case 'change-contractor':
          this.clear();
          break;
        default:
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>
